import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class SubscriptionsService {
    private serverUrl = 'https://' + window.location.host; // TODO Get url and version number from appsettings.
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}/subscriptiontask/').replace(
        '{version}',
        this.version
    );

    constructor(private http: HttpClient) {}

    getClientSubscriptionTask(): Observable<IGetClientSubscriptionTask[]> {
        return this.http.post<IGetClientSubscriptionTask[]>(
            this._url + 'getClientSubscriptionTask',
            {
                headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
            }
        );
    }

    upsertClientSubscriptionTask(
        parameters: IUpsertClientSubscriptionTaskParameters
    ): Observable<number[]> {
        return this.http.post<number[]>(this._url + 'upsertClientSubscriptionTask', parameters, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        });
    }

    getSubscriptionTasks(): Observable<IGetSubscriptionTasks[]> {
        return this.http.post<IGetSubscriptionTasks[]>(this._url + 'getSubscriptionTasks', {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        });
    }

    getClientSubscriptionTaskPositions(): Observable<IGetClientSubscriptionTaskPositions[]> {
        return this.http.post<IGetClientSubscriptionTaskPositions[]>(
            this._url + 'getClientSubscriptionTaskPositions',
            {
                headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
            }
        );
    }

    upsertClientSubscriptionTaskPosition(
        parameters: IUpsertClientSubscriptionTaskPositionParameters
    ): Observable<number[]> {
        return this.http.post<number[]>(
            this._url + 'upsertClientSubscriptionTaskPosition',
            parameters,
            {
                headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
            }
        );
    }

    getUserSubscriptionTasks(): Observable<IGetUserSubscriptionTasks[]> {
        return this.http.post<IGetUserSubscriptionTasks[]>(this._url + 'getUserSubscriptionTasks', {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        });
    }

    upsertUserSubscriptionTask(
        parameters: IUpsertUserSubscriptionTaskParameters
    ): Observable<number[]> {
        return this.http.post<number[]>(this._url + 'upsertUserSubscriptionTask', parameters, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        });
    }
}
export interface IUpsertClientSubscriptionTaskParameters {
    subscriptionTaskKey: number;
    isActive: boolean;
}

export interface IGetClientSubscriptionTask {
    subscriptionTaskKey: number;
    name: string;
    description: string;
    schedule: string;
    clientSubscriptionTaskKey?: string;
    isActive?: boolean;
    enabledStaffPositions?: string;
    doesPositionMatch?: boolean;
    isInactiveCompanySubscription?: boolean;
    enabled?: boolean;
    hasNoUserSub?: boolean;
    dropdownListSettings?: any;
}

export interface IGetSubscriptionTasks {
    subscriptionTaskKey: number;
    name: string;
    description: string;
    schedule: string;
    lastMod: Date;
    lastModUserKey: number;
}

export interface IGetClientSubscriptionTaskPositions {
    clientSubscriptionTaskKey: number;
    staffPositionKey: number;
    isActive: boolean;
    position: string;
}

export interface IUpsertClientSubscriptionTaskPositionParameters {
    clientSubscriptionTaskKey: number;
    staffPositionKey: number;
    isActive: boolean;
}

export interface IGetUserSubscriptionTasks {
    clientSubscriptionTaskKey: number;
    userSubscriptionTaskKey: number;
    userKey: number;
    name: string;
    description: string;
    schedule: string;
    enabled: boolean;
    enabledStaffPositions?: string;
    doesPositionMatch?: boolean;
    isActive?: boolean;
    isInactiveCompanySubscription?: boolean;
    hasNoUserSub?: boolean;
}

export interface IUpsertUserSubscriptionTaskParameters {
    clientSubscriptionTaskKey: number;
    isActive: boolean;
}
